import Axios from 'axios'
import url from '../requestPrefix'
import file from './file'
import { getType } from './index'

const options = {
  timeout: '',
  partSize: '',
  parallel: '',
  retryCount: '',
  retryDuration: '',
  region: 'cn-shanghai',
  userId: '1125689273028620',
  file: null,
  authProgress: 0,
  uploadDisabled: true,
  resumeDisabled: true,
  pauseDisabled: true,
  uploader: null,
  statusText: ''
}
/**
 * 获取视频上传凭证
 */
export function uploadVideoGet(data) {
  return Axios({
    url: url.fileUrl + '/uploadVideo/get',
    method: 'get',
    params: data
  })
}
/**
 * 刷新凭证
 */
export function uploadVideoRefresh(data) {
  return Axios({
    url: url.fileUrl + '/uploadVideo/refresh',
    method: 'get',
    params: data
  })
}
/**
 * 获取视频播放地址
 */
export function getPlayInfo(data) {
  return Axios({
    url: url.fileUrl + '/video/getPlayInfo',
    method: 'get',
    params: { videoId: data }
  })
}
/**
 * 获取视频播放凭证
 */
export function getPlayAuth(data) {
  return Axios({
    url: url.fileUrl + '/video/getPlayAuth',
    method: 'get',
    params: { videoId: data }
  })
}
/**
 * 创建上传对象
 * 创建对象后调用方法
 * 开始上传 startUpload();
 * 停止上传 stopUpload();
 */
export function createUploader() {
  // eslint-disable-next-line no-undef
  const uploader = new AliyunUpload.Vod({
    timeout: options.timeout || 60000,
    partSize: options.partSize || 1048576,
    parallel: options.parallel || 5,
    retryCount: options.retryCount || 3,
    retryDuration: options.retryDuration || 2,
    region: options.region,
    userId: options.userId,
    // 添加文件成功
    addFileSuccess: function(uploadInfo) {
      options.uploadDisabled = false
      options.resumeDisabled = false
      options.statusText = '添加文件成功, 等待上传...'
      console.log('addFileSuccess: ' + uploadInfo.file.name)
    },
    // 开始上传
    onUploadstarted: function(uploadInfo) {
      console.log('开始上传', uploadInfo)
      // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
      // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
      // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
      if (uploadInfo.videoId) {
        // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口
        uploadVideoRefresh({ videoId: uploadInfo.videoId }).then(res => {
          const data = res.data.data
          const uploadAuth = data.uploadAuth
          const uploadAddress = data.uploadAddress
          const videoId = data.videoId
          uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
        })
        options.statusText = '文件开始上传...'
      } else {
        console.log('文件开始上传', uploadInfo)
        // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口
        uploadVideoGet({ name: uploadInfo.file.name }).then(res => {
          console.log(res)
          const data = res.data.data
          const uploadAuth = data.uploadAuth
          const uploadAddress = data.uploadAddress
          const videoId = data.videoId
          uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
        })
      }
    },
    // 文件上传成功
    onUploadSucceed: function(uploadInfo) {
      console.log('onUploadSucceed: ' + uploadInfo.file.name + ', endpoint:' + uploadInfo.endpoint + ', bucket:' + uploadInfo.bucket + ', object:' + uploadInfo.object)
      options.statusText = '文件上传成功!'
      const fileData = { name: uploadInfo.videoId, originalName: uploadInfo.file.name, suffix: getType(uploadInfo.file.name), size: uploadInfo.file.size, type: 100 }
      file.save(fileData).then(res => {
        console.log('服务器保存成功')
      })
      console.log('文件上传成功', uploadInfo)
    },
    // 文件上传失败
    onUploadFailed: function(uploadInfo, code, message) {
      console.log('onUploadFailed: file:' + uploadInfo.file.name + ',code:' + code + ', message:' + message)
      options.statusText = '文件上传失败!'
    },
    // 取消文件上传
    onUploadCanceled: function(uploadInfo, code, message) {
      console.log('Canceled file: ' + uploadInfo.file.name + ', code: ' + code + ', message:' + message)
      options.statusText = '文件已暂停上传'
    },
    // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
    onUploadProgress: function(uploadInfo, totalSize, progress) {
      console.log('onUploadProgress:file:' + uploadInfo.file.name + ', fileSize:' + totalSize + ', percent:' + Math.ceil(progress * 100) + '%')
      const progressPercent = Math.ceil(progress * 100)
      options.authProgress = progressPercent
      options.statusText = '文件上传中...'
    },
    // 上传凭证超时
    onUploadTokenExpired: function(uploadInfo) {
      uploadVideoRefresh({ videoId: uploadInfo.videoId }).then(res => {
        const data = res.data.data
        const uploadAuth = data.uploadAuth
        uploader.resumeUploadWithAuth(uploadAuth)
        console.log('upload expired and resume upload with uploadauth ' + uploadAuth)
      })
      options.statusText = '文件超时...'
    },
    // 全部文件上传结束
    onUploadEnd: function(uploadInfo) {
      console.log('onUploadEnd: uploaded all the files')
      options.statusText = '文件上传完毕'
    }
  })
  return uploader
}



// WEBPACK FOOTER //
// ./src/api/file/video.js